import * as React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Breadcrumb({ className, ...props }: React.HTMLAttributes<HTMLElement>) {
  return <nav aria-label="Breadcrumb" className={className} {...props} />;
}

export function BreadcrumbList({ className, ...props }: React.OlHTMLAttributes<HTMLOListElement>) {
  return (
    <ol className={cn('flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground', className)} {...props} />
  );
}

export function BreadcrumbItem({ className, ...props }: React.LiHTMLAttributes<HTMLLIElement>) {
  return <li className={cn('inline-flex items-center gap-1.5', className)} {...props} />;
}

export const BreadcrumbLink = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { asChild?: boolean }
>(({ className, asChild, children, ...props }, ref) => {
  const linkClassName = cn('transition-colors hover:text-foreground', className);
  // asChild clones the single child (e.g. a router <Link>) instead of
  // rendering a raw <a> — so navigation stays inside the SPA router.
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children as React.ReactElement, {
      className: cn(linkClassName, (children as React.ReactElement).props.className),
      ...props,
    });
  }
  return (
    <a ref={ref} className={linkClassName} {...props}>
      {children}
    </a>
  );
});
BreadcrumbLink.displayName = 'BreadcrumbLink';

export function BreadcrumbPage({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span aria-current="page" className={cn('font-medium text-foreground', className)} {...props} />;
}

export function BreadcrumbSeparator({ className, ...props }: React.LiHTMLAttributes<HTMLLIElement>) {
  return (
    <li role="presentation" aria-hidden="true" className={cn('[&>svg]:h-3.5 [&>svg]:w-3.5', className)} {...props}>
      <ChevronRight />
    </li>
  );
}
